import { useCallback, useEffect, useState } from 'react';
import { fetchCampaignMetrics, type CampaignMetric } from '@/services/campaigns';

// Carga las métricas operativas (registro diario/periodico) de todas las
// campañas. La página las agrupa por campaña para el panel operativo.
export function useCampaignMetrics() {
  const [data, setData] = useState<CampaignMetric[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchCampaignMetrics()
      .then((res) => {
        if (cancelled) return;
        setData(res);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Error al cargar las métricas de campaña');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => load(), [load]);

  return { data, loading, error, refetch: load };
}